import React from 'react'

export const US_LETTER = 'US_LETTER'
export const A4 = 'A4'

export const PAPER_SIZE_LABELS = {[US_LETTER]:"US Letter",[A4]:"A4"}

export const PAPER_SIZE_OPTIONS = Object.keys(PAPER_SIZE_LABELS)
